import { Component, OnInit } from '@angular/core';
import { StandardResponse } from 'src/app/models/common.model';
import { Course } from 'src/app/models/course.model';
import { CourseService } from 'src/app/services/course.service';

@Component({
  selector: 'app-manage-course',
  templateUrl: './manage-course.component.html',
  styleUrls: ['./manage-course.component.scss']
})
export class ManageCourseComponent implements OnInit {
  constructor(private courseService: CourseService) {}

  courses!: Course[];
  ngOnInit() {
    this.courseService.getCourses().subscribe((courses: StandardResponse<Course>) => {
      this.courses = courses.results
    })
  }
}
